import store from '@state/store'

const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/pages/account/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/pages/account/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () =>
      lazyLoadView(import('@views/pages/account/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        next(
          authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom }
        )
      },
    },
  },
]

// error pages
const errorPagesRoutes = [
  {
    path: '/404',
    name: '404',
    component: require('@views/pages/other/error-404').default,
    props: (route) => ({ user: store.state.auth.currentUser || {} }),

  },
  {
    path: '/500',
    name: '500',
    component: require('@views/pages/other/error-500').default,
    props: (route) => ({ user: store.state.auth.currentUser || {} }),

  },
  {
    path: '*',
    redirect: '404',
  },
]


const dashboardRoutes = [
  {
    path: '/',
    name: 'dashboard',
    header: 'dashboard',
    icon: 'file',
    component: () => lazyLoadView(import('@views/pages/dashboard')),
    meta: { authRequired: true, role : ['ROOT', 'ADMIN'] },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]

const dataPegawaiRoutes = [
  {
    path: '/data-pegawai',
    name: 'Data Pegawai',
    header: 'Data Pegawai',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/data-pegawai')),
    meta: { authRequired: true, role : ['ROOT', 'ADMIN'] },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
]



const mainRoutes = [
  ...dashboardRoutes,
  ...dataPegawaiRoutes
]

const allRoutes = [
  ...authRoutes, 
  ...mainRoutes,
  ...errorPagesRoutes,
]

export { allRoutes, mainRoutes}


function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require('@components/_loading').default,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
